import { Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../configuration';
import { AbstractApiController } from './abstract-api-controller';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ContactMessageApi extends AbstractApiController {

  constructor(
    private http: HttpClient,
    @Optional() config?: Configuration
  ) {
    super();
    this.baseUrl = (config && config.apiBaseUrl)
      ? config.apiBaseUrl : 'https://example.com';
  }

  public send(request) {
    return this.http.post<any>(
      this.baseUrl + '/api/cf/contact-form/send?appId=' + environment.appId,
      request
    );
  }
}
